
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Mistralairblanketwarmer() {



  const cardData =
  {
    keyword: 'Mistral Air Blanket Warmer Machine',
    heading: 'Pharmacle Health Care Private Limited: Mistral Air Blanket Warmer Machine',
    headingDescription: 'Pharmacle Health Care Private Limited acknowledges the significance of advanced patient warming technologies like the Mistral-Air® Blanket Warmer Machine, which plays a crucial role in maintaining normothermia during surgical procedures. Manufactured by The Surgical Company International, the Mistral-Air® system utilizes forced-air warming to deliver consistent and controlled heat, effectively preventing perioperative hypothermia and enhancing patient safety. Widely adopted in hospitals and healthcare facilities across India, this system is known for its reliability, ease of use, and integration of cutting-edge technology. By incorporating such advanced warming solutions, healthcare providers can significantly improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


 "topPlaces": [
  {
    "title": "Pharmacle Patient Warmer Device – Advanced Temperature Management",
    "description": "Pharmacle Health Care Private Limited designs and manufactures the Pharmacle Patient Warmer Device, built to maintain normothermia during surgeries. Featuring advanced HEPA filtration (99.95% efficiency) and controlled diffusion technology, it delivers uniform heating with integrated safety sensors for reliable use in clinical environments."
  },
  {
    "title": "Pharmacle MA1200 – Efficient and Quiet Patient Warming Solution",
    "description": "The Pharmacle MA1200, developed by Pharmacle Health Care Private Limited, is a compact and lightweight warming unit that delivers consistent heat control within 60 seconds. Its aerodynamic and quiet design enhances surgical environments, and it integrates seamlessly with Pharmacle warming blankets."
  },
  {
    "title": "Pharmacle Warming Blankets – Versatile Patient Warming Solutions",
    "description": "Pharmacle Health Care Private Limited manufactures high-quality warming blankets in multiple configurations, including upper body, lower body, underbody, and full body. Available in Plus and Premium models, they ensure safe, uniform heat distribution across all surgical and critical care applications."
  },
  {
    "title": "Pharmacle Health Care Private Limited – Manufacturer & Distributor",
    "description": "As a leading manufacturer and distributor, Pharmacle Health Care Private Limited provides complete patient warming systems, including devices and compatible blankets. We serve hospitals, surgical centers, and ICUs across India with reliable, safe, and advanced thermal management solutions."
  },
  {
    "title": "Pharmacle Heat Therapy Systems – Complete Warming Care",
    "description": "Pharmacle Health Care Private Limited also delivers full heat therapy systems, including mobile trolleys and body-covering warming sets. These systems prevent hypothermia before, during, and after surgery, reducing infection risks and improving recovery times."
  }
],

"services": [
    {
        "name": "Mistral Air Blanket Warmer Machine",
        "description": "Pharmacle Health Care offers the Mistral Air Blanket Warmer Machine, designed to deliver efficient convective warming during surgeries and critical care. This machine provides a steady flow of warm air through compatible blankets, helping to prevent hypothermia and enhance patient comfort throughout treatment and recovery. Built for clinical precision, it supports safe and consistent temperature regulation in various medical settings."
    },
    {
        "name": "Mistral Surgical Warming Blanket",
        "description": "We provide the Mistral Surgical Warming Blanket, specifically designed for use during surgical procedures to maintain patient body temperature. Integrated with forced air technology, these blankets help reduce surgical complications by maintaining normothermia. Pharmacle Health Care’s warming blankets are known for their reliability, patient safety, and compatibility with Mistral air warming units."
    },
    {
        "name": "Mistral Forced Air Blanket System",
        "description": "The Mistral Forced Air Blanket System delivers effective temperature management using warm air circulation through specialized blankets. Ideal for use in surgical theaters and recovery rooms, this system helps to stabilize patient temperature, prevent hypothermia, and improve overall clinical outcomes. Pharmacle Health Care supplies complete systems tailored to various hospital needs."
    },
    {
        "name": "Mistral Patient Thermoregulation Equipment",
        "description": "Pharmacle Health Care supplies Mistral Patient Thermoregulation Equipment designed for advanced temperature control during medical procedures. Using convective heat distribution, these systems provide uniform body warming, enhancing patient safety and comfort. Suitable for operating rooms, ICUs, and recovery areas, they are essential in modern thermoregulation protocols."
    },
    {
        "name": "Mistral Operating Room Blanket Warmer",
        "description": "We offer the Mistral Operating Room Blanket Warmer, a high-performance device for maintaining patient warmth during surgery. It uses convective heat to deliver precise temperature control, minimizing the risk of hypothermia and contributing to better surgical outcomes. Pharmacle Health Care’s OR warming devices are designed for seamless integration into surgical workflows."
    },
    {
        "name": "Mistral Heat Therapy System",
        "description": "The Mistral Heat Therapy System provides safe and efficient heat delivery for patients undergoing surgery or recovery. It uses warm air flow technology to ensure consistent body temperature, helping prevent complications due to thermal instability. Trusted by hospitals and surgical centers, this system enhances both patient comfort and clinical safety."
    },
    {
        "name": "Mistral Hospital Warming Devices",
        "description": "Pharmacle Health Care supplies Mistral Hospital Warming Devices, tailored to meet the demanding needs of hospital environments. These devices use forced air warming to help regulate patient temperature during procedures and in post-operative care. With intuitive controls and reliable performance, Mistral systems are ideal for a variety of hospital applications."
    }
],
"tableData": [
    ["- Mistral Air Blanket Warmer Machine", "- Mistral Surgical Warming Blanket"],
    ["- Mistral Forced Air Blanket System", "- Mistral Patient Thermoregulation Equipment"],
    ["- Mistral Operating Room Blanket Warmer", "- Mistral Heat Therapy System"],
    ["- Mistral Hospital Warming Devices"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "The Mistral Air Blanket Warmer Machine utilizes advanced technology to provide controlled and consistent warmth to patients during medical procedures. Its precise temperature regulation helps prevent hypothermia, ensuring patient comfort and safety during surgeries and recovery."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "The Mistral Air Blanket Warmer Machine is part of a comprehensive range of warming solutions, designed to provide consistent warmth during surgeries, post-operative care, and other medical treatments. This system is ideal for keeping patients at optimal temperatures throughout their procedures."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Manufactured to the highest standards, the Mistral Air Blanket Warmer Machine is built for long-lasting performance in demanding healthcare environments. Its durable design ensures reliability, providing consistent results and a long service life, making it a trusted choice for medical facilities."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are the top priorities with the Mistral Air Blanket Warmer Machine. It delivers controlled, gentle warmth, preventing temperature-related complications such as hypothermia during surgeries, ensuring patients are comfortable and safe at all times."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "The Mistral Air Blanket Warmer Machine is highly adaptable and suitable for a wide range of healthcare settings, including hospitals, operating rooms, recovery areas, and intensive care units. It can be customized to meet the unique needs of healthcare providers, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "The Mistral Air Blanket Warmer Machine is designed for easy integration with existing medical systems, ensuring a smooth and efficient operation within any healthcare facility. Its user-friendly interface makes it simple to implement without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation and support to healthcare providers using the Mistral Air Blanket Warmer Machine. Our team is available for ongoing maintenance, troubleshooting, and guidance to ensure the system continues to perform optimally and support patient care."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we are committed to ensuring the highest standards of patient care. The Mistral Air Blanket Warmer Machine is designed to maintain optimal patient temperature during critical medical procedures, providing a safe and comfortable experience throughout."
    }
]






















  }

  const faqData = [
    {
      question: "What is the Mistral Air Blanket Warmer Machine?",
      answer: "The Mistral Air Blanket Warmer Machine is a forced air warming system designed to maintain a patient's body temperature during surgical procedures. It uses a high-volume blower to circulate warm, filtered air through specially designed blankets, ensuring even heat distribution and preventing hypothermia."
    },
    {
      question: "How does the Mistral Air Blanket Warmer Machine work?",
      answer: "The system operates by blowing warm air through a low-pressure blanket that is placed over or under the patient. The aerodynamic design of the blanket ensures even heat distribution, while the HEPA H13 filter in the unit removes 99.95% of airborne particles, providing clean and safe warmth."
    },
    {
      question: "Is the Mistral Air Blanket Warmer Machine suitable for all types of surgeries?",
      answer: "Yes, the Mistral Air Blanket Warmer Machine is versatile and can be used in a wide range of surgical procedures, including orthopedic, cardiac, and general surgeries, where maintaining normothermia is crucial for patient safety and recovery."
    },
    {
      question: "What are the key features of the Mistral Air Blanket Warmer Machine?",
      answer: "Key features include fast warming at the push of a button, smart warming with even heat distribution, high-efficiency filtration, sensors and alarms for trusted patient warming, and ergonomic design for easy integration into surgical environments."
    },
    {
      question: "Where can I purchase the Mistral Air Blanket Warmer Machine in India?",
      answer: "The Mistral Air Blanket Warmer Machine is available through authorized distributors and medical equipment suppliers in India. It's advisable to contact TSC Life or their official distributors for purchasing information."
    }
  ];
  
  const testimonialsData = [
    {
      text: "The Mistral Air Blanket Warmer Machine has significantly improved our ability to maintain patient body temperature during surgeries, leading to better patient outcomes.",
      name: "Dr. Rajesh Kumar, Apollo Hospital"
    },
    {
      text: "We have been using the Mistral Air Blanket Warmer Machine in our clinic, and it has proven to be reliable and effective in preventing hypothermia during procedures.",
      name: "Dr. Priya Mehta, City Clinic"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  // const jsonData = {
  //   "@context": "https://schema.org",
  //   "@type": "Product",
  //   "name": "Mistral Air Blanket Warmer Machine",
  //   "description": "Get the Mistral Air Blanket Warmer Machine – a trusted solution for surgical patient warming, forced air heat therapy, and hospital thermoregulation using Mistral’s advanced operating room technology.",
  //   "brand": {
  //     "@type": "Brand",
  //     "name": "Mistral"
  //   },
  //   "aggregateRating": {
  //     "@type": "AggregateRating",
  //     "bestRating": "5",
  //     "worstRating": "1",
  //     "ratingValue": "4.7",
  //     "ratingCount": "1245"
  //   }
  // };
  
const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mistral Air Blanket Warmer Machine",
  "image": "https://www.yoursite.com/images/mistral-air-warmer.jpg", // ✅ real, fast-loading image
  "description": "Get the Mistral Air Blanket Warmer Machine – a trusted solution for surgical patient warming, forced air heat therapy, and hospital thermoregulation using Mistral’s advanced operating room technology.",
  "brand": {
    "@type": "Brand",
    "name": "Mistral"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "reviewCount": "1245",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Dr. Ramesh Verma"
    },
    "reviewBody": "The Mistral blanket warmer has improved our surgical efficiency and patient outcomes. Highly reliable and easy to operate in the OT."
  },
  "offers": {
    "@type": "Offer",
    "price": "Contact for best quote",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.yoursite.com/mistral-air-warmer"
  }
};


  

  return (
    <div>



<Helmet>
  <title>Mistral Air Blanket Warmer Machine – Surgical Patient Heat Therapy</title>
  <meta
    name="description"
    content="Buy Mistral Air Blanket Warmer Machine – India's trusted surgical patient warming solution. Ensures effective thermoregulation in operating rooms and ICUs. Contact: +91 8956322311."
  />
  <meta
    name="keywords"
    content="Mistral Air Blanket Warmer Machine, Surgical Patient Heating Machine, Mistral Thermoregulation Device, Forced Air Blanket Warmer India, Mistral Operating Room Warming System, Heat Therapy Surgical Device, Mistral Warming Blanket Supplier"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>







  {/* <Helmet>
    <title>Mistral Air Blanket Warmer Machine | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover the Mistral Air Blanket Warmer Machine for surgical use. Mistral offers patient thermoregulation devices, heat therapy systems, and hospital warming equipment. Contact +91 8956322311."
    />
    <meta
      name="keywords"
      content="Mistral Air Blanket Warmer Machine, Mistral Surgical Warming Blanket, Mistral Forced Air Blanket System, Mistral Patient Thermoregulation Equipment, Mistral Operating Room Blanket Warmer, Mistral Heat Therapy System, Mistral Hospital Warming Devices"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet> */}
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/57.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mistralairblanketwarmer;